import React from 'react';

import CachedImage from '@components/CachedImage/CachedImage';
import theme from '@themes/theme';

import { Team, LocalFile } from '../../graphql/generated';
import { Box, Text } from '../Restyle';
import Icon from '../shared/Icon/Icon';

interface TeamAvatarProps {
  team: Team;
}

const TeamAvatar: React.FC<TeamAvatarProps> = ({ team }) => {
  const { avatarFile, name, personal } = team;
  return (
    <>
      {avatarFile ? (
        <CachedImage
          avatarType='team'
          avatarId={avatarFile.id}
          image={avatarFile as unknown as LocalFile}
          width={40}
          height={40}
          borderRadius={theme.spacing.xs}
        />
      ) : (
        <Box
          width={40}
          height={40}
          borderRadius='xs'
          backgroundColor='greenSecondary'
          alignItems='center'
          justifyContent='center'>
          {personal ? (
            <Icon name='Office' color='white' variant='l' />
          ) : (
            <Text color='white' variant='labelLarge'>
              {name.charAt(0)}
            </Text>
          )}
        </Box>
      )}
    </>
  );
};

export default TeamAvatar;
